


export const FETCH_ALL_DIRECT_BILLING_DETAILS_DATA_REQUEST = 'FETCH_ALL_DIRECT_BILLING_DETAILS_DATA_REQUEST';
export const FETCH_ALL_DIRECT_BILLING_DETAILS_DATA_SUCCESS = 'FETCH_ALL_DIRECT_BILLING_DETAILS_DATA_SUCCESS';
export const FETCH_ALL_DIRECT_BILLING_DETAILS_DATA_FAILURE = 'FETCH_ALL_DIRECT_BILLING_DETAILS_DATA_FAILURE';




export const FETCH_DIRECT_BILLING_DETAILS_DATA_BY_ID_REQUEST = 'FETCH_DIRECT_BILLING_DETAILS_DATA_BY_ID_REQUEST';
export const FETCH_DIRECT_BILLING_DETAILS_DATA_BY_ID_SUCCESS = 'FETCH_DIRECT_BILLING_DETAILS_DATA_BY_ID_SUCCESS';
export const FETCH_DIRECT_BILLING_DETAILS_DATA_BY_ID_FAILURE = 'FETCH_DIRECT_BILLING_DETAILS_DATA_BY_ID_FAILURE';

export const CREATE_DIRECT_BILLING_DETAILS_MASTER_USERFORM = 'CREATE_DIRECT_BILLING_DETAILS_MASTER_USERFORM';

export const CREATE_DIRECT_BILLING_DETAILS_REQUEST = 'CREATE_DIRECT_BILLING_DETAILS_REQUEST';
export const CREATE_DIRECT_BILLING_DETAILS_SUCCESS = 'CREATE_DIRECT_BILLING_DETAILS_SUCCESS';
export const CREATE_DIRECT_BILLING_DETAILS_FAILURE = 'CREATE_DIRECT_BILLING_DETAILS_FAILURE';

export const UPDATE_DIRECT_BILLING_DETAILS_REQUEST = 'UPDATE_DIRECT_BILLING_DETAILS_REQUEST';
export const UPDATE_DIRECT_BILLING_DETAILS_SUCCESS = 'UPDATE_DIRECT_BILLING_DETAILS_SUCCESS';
export const UPDATE_DIRECT_BILLING_DETAILS_FAILURE = 'UPDATE_DIRECT_BILLING_DETAILS_FAILURE';

export const DELETE_DIRECT_BILLING_DETAILS_DATA_REQUEST = 'DELETE_DIRECT_BILLING_DETAILS_DATA_REQUEST';
export const DELETE_DIRECT_BILLING_DETAILS_DATA_SUCCESS = 'DELETE_DIRECT_BILLING_DETAILS_DATA_SUCCESS';
export const DELETE_DIRECT_BILLING_DETAILS_DATA_FAILURE = 'DELETE_DIRECT_BILLING_DETAILS_DATA_FAILURE';

export const DIRECT_BILLING_DETAILS_RESET_USERFORM = 'DIRECT_BILLING_DETAILS_RESET_USERFORM';